import App from 'app/app.js';
import 'app/directive/LtAddressConfirmationCtrl.js';
import addressConfirmationTemplate from 'html/checkout/addressConfirmation.html';

function LtAddressConfirmationDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      navigateUser: '&',
      isOrderEditPage: '=',
      setSuggestedAddressToForm: '&',
      suggestedAddressObj: '&',
      setShippingAddressToSuggestedAddress: '&',
      setShippingAddressToOriginalAddress: '&',
      populateAddress: '&'
    },
    template: addressConfirmationTemplate,
    controller: 'LtAddressConfirmationCtrl',
    controllerAs: 'addressConfirmation'
  };
}

App.directive('ltAddressConfirmation', [LtAddressConfirmationDirective]);
